(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('pending-cases', {
            parent: 'application',
            url: '/pending-cases',
            data: {
                pageTitle: 'global.menu.pending-cases'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/pending-cases/pending-cases.html',
                    controller: 'PendingCasesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pending-cases');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
